import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ApiService} from '../../../../utils/services/api.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class DepositResolverService implements Resolve<any> {

  constructor(private apiService: ApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {

    let organizationID = route.parent.params.id;
    let agencyCrossID = route.params.crossID;

    return this.apiService.getOrganizationDeposits(organizationID, agencyCrossID).map(
      (response) => {
        return response['data'].rows[0];
      }
    ).catch((error) => {
      return Observable.of(null);
    });
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/deposit/resolver/deposit-resolver.service.ts